module.exports = __webpack_public_path__ + "media/newstyle/images/book-upload-icon-7c895cdb643c8db37c6c0902777e22ec.svg";